import React from "react";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import RefreshIcon from '@material-ui/icons/Refresh';
import CachedIcon from '@material-ui/icons/Cached';
import ShareIcon from '@material-ui/icons/Share';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import ModalForm from "../components/ModalForm";
import "../styles/questionStyles.css";
import "../styles/masterStyles.css";

export const NextPrevButton = props => {
    const func = (type) => {
        return props.func();;
    }
    if (typeof props.gameMode !== 'undefined') {
        if (props.gameMode < 3) {
            if (props.prev) {
                return (
                    <Button
                        className="icon-widget"
                        style={{
                            backgroundColor: props.backgroundColor,
                        }}
                        onClick={() => func('prev')}
                    >
                        <ArrowBackIcon 
                            className="text-white"
                        />
                    </Button>
                )
            } else if (props.next) {
                return (
                    <Button 
                        className="icon-widget"
                        style={{
                            backgroundColor: props.backgroundColor,
                        }}
                        onClick={() => func('next')}
                    >
                        <ArrowForwardIcon 
                            className="text-white"
                        />
                    </Button>
                )
            } else {
                return (
                    <div style={{height: "36px", width: "36px"}}> </div>
                )
            }
        } else if (props.gameMode > 2) {
            if (props.refresh) {
                return (
                    <Button 
                        className="icon-widget"
                        style={{
                            backgroundColor: props.backgroundColor,
                        }}
                        onClick={() => func('refresh')}
                    >
                        <RefreshIcon 
                            className="text-white"
                        />
                    </Button>
                )
            } else {
                return (
                    <div style={{height: "36px", width: "36px"}}> </div>
                )
            }
        }  
    } else if (typeof props.sharable !== 'undefined') {
        return (
            <ModalForm 
                type={props.type}
                color={props.backgroundColor}
                func={props.func}
            />
        )

        switch(props.type) {
            case 'email': {
                return (
                    <ModalForm 
                        type="email"
                        color={props.backgroundColor}
                        func={props.func}
                    />
                )
            }

            case 'reset': {
                return (
                    <ModalForm 
                        type="reset"
                        color={props.backgroundColor}
                        func={props.func}
                    />
                    // <Button
                    //     className="icon-widget"
                    //     style={{
                    //         backgroundColor: props.backgroundColor,
                    //     }}
                    //     onClick={() => func('reset')}
                    // >
                    //     <CachedIcon 
                    //         className="text-white"
                    //     />
                    // </Button>
                )
            }

            case 'share': {
                return (
                    <ModalForm 
                        type={props.type}
                        color={props.backgroundColor}
                        func={props.func}
                    />
                    // <Button
                    //     className="icon-widget"
                    //     style={{
                    //         backgroundColor: props.backgroundColor,
                    //     }}
                    //     onClick={() => func('reset')}
                    // >
                    //     <ShareIcon 
                    //         className="text-white"
                    //         style={{
                    //             fontSize: "0.9em",
                    //         }}
                    //     />
                    // </Button>
                )
            }

            default: {
                return (
                    <div style={{height: "36px", width: "36px"}}> </div>
                )
            }

        }
    }
}; 